import { useRealTimeTypedQuery } from "components";
import { useHoldingsListeners } from "modules/HoldingsDashboard/listeners";
import { HoldingsQueryKeys } from "modules/HoldingsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { Holding } from "models";

const sortHoldings = (holdings: Holding[]) => holdings.sort((a, b) => a.id - b.id);

export const useHoldingsQuery = () => {
  const listeners = useHoldingsListeners();

  return useRealTimeTypedQuery({
    queryKey: HoldingsQueryKeys.list,
    queryFn: async ({ endpoint, baseUrl }) => (await ApiInstance.get(endpoint, baseUrl)).data.holdings,
    select: sortHoldings,
    listeners
  });
};
